module.exports = __webpack_public_path__ + "static/media/switch-provider-active.118d059d.svg";